export default __webpack_public_path__ + "static/media/dreamfest (5).6fb5aa5c.jpg";